"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_CODE_TOO_MANY_REQUESTS = exports.STATUS_CODE_TOO_BUSY = exports.STATUS_CODE_UNAUTHORIZED = void 0;
exports.isUnauthorizedError = isUnauthorizedError;
exports.isTooManyRequestsError = isTooManyRequestsError;
exports.isTooBusyError = isTooBusyError;
exports.isBannedError = isBannedError;
exports.getBannedError = getBannedError;
const STATUS_CODE_UNAUTHORIZED = 401;
exports.STATUS_CODE_UNAUTHORIZED = STATUS_CODE_UNAUTHORIZED;
const STATUS_CODE_FORBIDDEN = 403;
const STATUS_CODE_TOO_MANY_REQUESTS = 429;
exports.STATUS_CODE_TOO_MANY_REQUESTS = STATUS_CODE_TOO_MANY_REQUESTS;
const STATUS_CODE_TOO_BUSY = 503;
exports.STATUS_CODE_TOO_BUSY = STATUS_CODE_TOO_BUSY;
function isUnauthorizedError(error) {
    return 'statusCode' in error && (error === null || error === void 0 ? void 0 : error.statusCode) === STATUS_CODE_UNAUTHORIZED;
}
function isTooManyRequestsError(error) {
    return 'statusCode' in error && (error === null || error === void 0 ? void 0 : error.statusCode) === STATUS_CODE_TOO_MANY_REQUESTS;
}
function isTooBusyError(error) {
    return 'statusCode' in error && (error === null || error === void 0 ? void 0 : error.statusCode) === STATUS_CODE_TOO_BUSY;
}
function isBannedError(error) {
    if ('statusCode' in error && (error === null || error === void 0 ? void 0 : error.statusCode) == STATUS_CODE_FORBIDDEN && 'result' in error) {
        const { result } = error;
        if (result instanceof Object && 'errors' in result) {
            return result.errors.some((item) => { var _a; return ((_a = item.extensions) === null || _a === void 0 ? void 0 : _a.code) === 'BLOCKED'; });
        }
    }
    return false;
}
function getBannedError(error) {
    if ('statusCode' in error && (error === null || error === void 0 ? void 0 : error.statusCode) == STATUS_CODE_FORBIDDEN && 'result' in error) {
        const { result } = error;
        if (result instanceof Object && 'errors' in result) {
            return result.errors.find((item) => { var _a; return ((_a = item.extensions) === null || _a === void 0 ? void 0 : _a.code) === 'BLOCKED'; });
        }
    }
    return null;
}
class FetchError extends Error {
    constructor(statusCode, message) {
        super(message);
        this.statusCode = statusCode;
    }
}
exports.default = FetchError;
//# sourceMappingURL=FetchError.js.map